// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-Content-module--cls1--1fYNQ","cls2":"Lightbox-Content-module--cls2--cNLZY Lightbox-Content-module--cls1--1fYNQ"};